import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
  timeout: 10 * 60 * 1000, //10 minutes
  headers: {'X-Custom-Header': 'golf'}
});

export default instance;
